import {Alert} from 'react-native';

import {store} from '../Redux/ReduxStore';

import {crashlytics} from './db';
import {setUseLocalHost} from '../Redux/reducers/app_info.reducer';

export const dispatchAction = (action) => {
  store.dispatch(action);
};

export const checkIfLocalServerAvailable = async () => {
  if (__DEV__) {
    console.log('testing if local host is available on dev');

    try {
      const localHostApi = await fetch('https://letsroam.local.com/api/test', {
        timeout: 10000,
      });
      console.log({localHostApi});
      dispatchAction(setUseLocalHost(1));
    } catch (error) {
      console.log(
        'localHostApi ping failed code',
        {error},
        error.code,
        error.message,
      );
      dispatchAction(setUseLocalHost(0));
    }
  }
};

export const logForCrashlytics = async (log, log_2 = '') => {
  console.log(log, log_2);
  try {
    crashlytics()?.log?.(log || 'No log info passed');
  } catch (error) {
    if (__DEV__) {
      console.log('logForCrashlytics', log);
      Alert.alert('Could not log chrashlytics log' + log, error.message);
    }
  }
};

export function ordinalSuffixOf(i) {
  logForCrashlytics('ordinalSuffixOf fired in helpers.js');
  var j = i % 10,
    k = i % 100;

  if (j == 1 && k != 11) {
    return i + 'st';
  }
  if (j == 2 && k != 12) {
    return i + 'nd';
  }
  if (j == 3 && k != 13) {
    return i + 'rd';
  }

  return i + 'th';
}

export const randomPhotoColor = (altColors) => {
  logForCrashlytics('randomPhotoColor fired in helpers.js');

  const colors = [
    global?.color?.teal,
    global?.color?.blue,
    global?.color?.gray3,
    global?.color?.gray2,
  ];

  const colors2 = [
    global?.color?.gray2,
    global?.color?.teal,
    global?.color?.blue,
    global?.color?.orange,
    global?.color?.yellow,
    global?.color?.orange,
  ];

  const colorSet = altColors ? colors2 : colors;

  return colorSet[Math?.floor(Math?.random() * colorSet?.length)];
};

export function parseHtmlEntities(str = '') {
  let newString = str;
  newString = newString
    ?.replace('&quot;', "'")
    .replace('&quot;', "'")
    .replace('&quot;', "'")
    .replace('&#7000;', "'")
    .replace('&quot;', "'");
  newString =
    newString?.replace?.(/&#([0-9]{1,3});/gi, function (match, numStr) {
      var num = parseInt(numStr, 10); // read num as normal number
      return String.fromCharCode(num);
    }) || '';

  return unescape(newString);
}

function random(seed = 0) {
  var x = Math.sin(seed++) * 10000;
  return x - Math.floor(x);
}

export const hashCode = (str = '') => {
  console.log(str);
  return str
    .split('')
    .reduce(
      (prevHash, currVal) =>
        ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
      0,
    );
};

export function seededShuffle(array = [], seedSting = '') {
  // <-- ADDED ARGUMENT
  var seed = hashCode(seedSting + 'string');

  var m = array?.length,
    t,
    i;

  // While there remain elements to shuffle…
  while (m) {
    // Pick a remaining element…
    i = Math.floor(random(seed) * m--); // <-- MODIFIED LINE

    // And swap it with the current element.
    t = array[m];
    array[m] = array[i];
    array[i] = t;
    ++seed; // <-- ADDED LINE
  }
  array.map?.((item, index) => {
    array[index]['key'] = index;
  });

  return array;
}

export const getReduxState = (path = []) => {
  const state = store.getState();
  // console.log('getReduxState', {state});
  var exportedStateItem = state;
  path?.map?.((item) => {
    exportedStateItem = exportedStateItem?.[item];
  });
  return exportedStateItem;
};

export const calculateFormatWalkingTime = (distanceMiles) => {
  if (distanceMiles < 2) {
    // based on avg of 10 minutes to walk 0.6 miles
    const walkingTime = Math?.floor((distanceMiles / 0.6) * 10);
    return `${walkingTime} min walk`;
  } else {
    return `${distanceMiles} miles away`;
  }
};

// using cloudflare to process images
// and resize them
export const cloudFlareOptimizeImage = (
  imageURI = '',
  width = 720,
  quality = 20,
) => {
  var processedImage = imageURI;
  if (
    // ignore already processed images
    !imageURI?.includes('cdn-cgi') &&
    // ignore urls that are too short
    imageURI?.length > 5 &&
    // ignore local urls
    !imageURI?.includes('letsroam.local.com:8888')
  ) {
    processedImage =
      `https://www.letsroam.com/cdn-cgi/image/width=${width},quality=${quality}/` +
      processedImage;
  }
  // console.log({processedImage});
  return processedImage;
};

export default {
  ordinalSuffixOf,
};
